import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "monitor",
    name: "Monitoring screens",
    version: "0.1.0",
    tier: "core",
    accent: "brand",
    dependsOn: ["sites"],
    description: "A live dashboard for the office TV: sign-offs, sales, tanks, jobs, connections and more, on its own secret link, locked to your company with a code, rotating page by page.",
    permissions: {
        view: "See the monitoring screens and the TVs showing them",
        manage: "Add monitoring screens, choose what they show, replace links and remove TVs",
    },
    grants: { "Head office": ["view", "manage"] },
    nav: [
        { label: "Monitoring screens", path: "/monitor", section: "operations", tab: "Sites", tabIcon: "pin", permission: "view", icon: "grid", order: 94, blurb: "The office TV dashboard: what it shows and which TVs use it" },
    ],
});
